<template>
  <div class="main-header">
    <div class="title">
      <slot/>
    </div>
    <img 
      v-if="$whitelabel === 'digifarm'" 
      src="../../assets/digifarm-logo.png"
      class="logo-digifarm"
    >
    <img 
      v-else 
      src="../../assets/logo-full.png"
      class="logo"
    >
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.main-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  height: 20mm;
  position: relative;
  width: 100%;
  background: #fff;

  .title {
    font-weight: bold;
    font-size: 23px;
  }

  .logo {
    width: auto;
    height: 50px;
  }

  .logo-digifarm {
    width: auto;
    height: 50px;
  }
}

</style>